import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'class-groups',
  name: '班级群',
  icon: '班',
  group: '校友会组件',
  description: '按届别和班级展示班级群入口。',
  defaultProps: {
    title: '班级群',
    limit: 6
}
}
